__turbopack_context__.v({
  "container": "E3k4xG_container",
  "content": "E3k4xG_content",
  "icon": "E3k4xG_icon",
});
